import React, { FunctionComponent } from 'react'
import { IPromise } from 'angular'
import { ServiceSaleRefundModal } from '../../../react/modals/service-sale-refund-modal/ServiceSaleRefundModal'
import { useSaleManager } from '../../../../ng-compat/hooks'
import { SERVICE_REFUND_ACTIONS } from '../../../../util/types'
import { useTransitionToPaymentScreen } from './use-transition-to-payment-screen'

interface SaleServiceModalProps {
  close: () => void
}

export const SaleServiceModal: FunctionComponent<SaleServiceModalProps> = ({
  close,
}) => {
  const transitionToPaymentScreen = useTransitionToPaymentScreen()
  const saleManager = useSaleManager()

  const handleClose = (
    resultPromise: IPromise<SERVICE_REFUND_ACTIONS> | undefined
  ) => {
    if (!resultPromise) {
      close()
      return
    }
    resultPromise.then(result => {
      switch (result) {
        case SERVICE_REFUND_ACTIONS.DISMISS:
          saleManager.clearSale()
          break
        case SERVICE_REFUND_ACTIONS.REFUND:
          transitionToPaymentScreen()
          break
      }
      close()
    })
  }

  return <ServiceSaleRefundModal close={handleClose} />
}
